/**
 * Maps FlatPickr date format tokens to dayjs format tokens.
 *
 * @param {string} fpFormat - FlatPickr format string (e.g. 'm/d/Y')
 * @returns {string} dayjs-compatible format string (e.g. 'MM/DD/YYYY')
 */
export function flatpickrFormatToDayjs(fpFormat) {
    if (!fpFormat) {
        return 'MM/DD/YYYY';
    }

    const tokenMap = {
        Y: 'YYYY',
        y: 'YY',
        m: 'MM',
        n: 'M',
        d: 'DD',
        j: 'D',
        F: 'MMMM',
        M: 'MMM',
        H: 'HH',
        h: 'hh',
        G: 'H',
        i: 'mm',
        S: 'ss',
        s: 'ss',
        K: 'A',
    };

    let result = '';
    let i = 0;

    while (i < fpFormat.length) {
        if (fpFormat[i] === '\\' && i + 1 < fpFormat.length) {
            result += fpFormat[i + 1];
            i += 2;
        } else if (tokenMap[fpFormat[i]]) {
            result += tokenMap[fpFormat[i]];
            i++;
        } else {
            result += fpFormat[i];
            i++;
        }
    }

    return result;
}

/**
 * Resolves a date reference to a Date object.
 * Handles 'today' string and date strings/Date objects.
 *
 * @param {string|Date|null|undefined} dateRef
 * @returns {Date|null}
 */
export function resolveDateRef(dateRef) {
    if (!dateRef) {
        return null;
    }

    if (dateRef === 'today') {
        return new Date();
    }

    if (dateRef instanceof Date) {
        return dateRef;
    }

    const parsed = new Date(dateRef);

    if (!isNaN(parsed.getTime())) {
        return parsed;
    }

    return null;
}
